/**
 * deviceTypeId → 展示名（与 GET /devices/my-session、MobileApp 一致）
 */
import { i18nService } from '../i18n/i18nService';

export const AMPLIFIER_DEVICE_TYPE_NAME = 'AMP-1000W';

export const DEVICE_TYPE_ID_TO_NAME: Record<number, string> = {
  1: 'Q900',
  2: 'HS2',
  3: 'QR20',
  4: 'TBR-119',
  5: 'PMR-119',
  6: 'SJR-188',
  7: 'PMR-171',
  8: 'XP-100',
  9: AMPLIFIER_DEVICE_TYPE_NAME,
};

/**
 * 后端在设备刚入会话时可能把 MQTT 客户端 ID 写入 name，非用户可见名称；
 * 此类占位应忽略，改用 deviceTypeId → 类型名（与刷新后 my-session 预期展示一致）。
 */
const MQTT_INTERNAL_NAME_PATTERN = /^mqtt-heartbeat-\d+/i;

/**
 * 优先用户命名；占位/内部名忽略后使用 deviceTypeId 对应类型名；仍无法解析则为「未命名」
 */
export function getSessionDeviceDisplayName(device: {
  name?: string;
  deviceTypeId?: number;
}): string {
  const raw = device.name?.trim();
  if (raw && !MQTT_INTERNAL_NAME_PATTERN.test(raw)) return raw;
  const tid = device.deviceTypeId;
  if (tid != null && Number.isFinite(tid) && DEVICE_TYPE_ID_TO_NAME[tid]) {
    return DEVICE_TYPE_ID_TO_NAME[tid];
  }
  return i18nService.t('common.unnamed');
}
